import { useFormContext } from 'react-hook-form';

import { MergeElementProps } from '@/core/interfaces/common';

import { forwardRefWrapper } from '@/utils/forwardRefWrapper';

import {
  StyledCharactersLimit,
  StyledContainer,
  StyledTextarea,
} from './Textarea.styles';
import {
  FieldErrorMessage,
  Label,
} from '../TextField/TextField.styles';

export type LabelElementProps = MergeElementProps<'label'>

export type TitleElementProps = MergeElementProps<'div'>

export type ContainerElementProps = MergeElementProps<'div'>

export type TextareaProps = MergeElementProps<
  'textarea', {
    id: string;
    name: string;
    characterLimit?: number;
  }
>;

const TextareaWrapped = ({
  id,
  key,
  placeholder,
  characterLimit = undefined,
  onBlur,
  onChange,
  onFocus,
  ...props
}: TextareaProps) => {
  const {
    name,
    disabled,
  } = props;
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();
  const fieldValue: string = watch(id) || '';

  return (
    <StyledContainer
      key={key}
      $isDisabled={disabled}
    >
      <Label
        $isError={!!errors[id]?.message}
        htmlFor={name}
      >
        {name}
      </Label>
      <StyledTextarea
        id={id}
        {...props}
        placeholder={placeholder}
        autoComplete="off"
        $isError={!!errors?.[id]}
        maxLength={characterLimit}
        onFocus={onFocus}
        {...register(id)}
      />
      {errors[id]?.message && (
      <FieldErrorMessage>
        {errors[id]?.message as string}
      </FieldErrorMessage>
      )}
      {characterLimit && (
        <StyledCharactersLimit $isError={!!errors[id]?.message}>
          {`${fieldValue.length}/${characterLimit}`}
        </StyledCharactersLimit>
      )}
    </StyledContainer>
  );
};

export const Textarea = forwardRefWrapper<TextareaProps>(TextareaWrapped);
